const state = {
  
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js